export default __webpack_public_path__ + "static/media/BLR28.5636fc42.jpg";